import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonDuplicatePage from '../../../components/Editor/ButtonDuplicatePage';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			combo: { isCombining },
			pageSelection: { pages },
		},
	} = state;

	return {
		isDisabled: isCombining || pages.length > 1,
	};
};

export default connect(mapStateToProps)(ButtonDuplicatePage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonDuplicatePage/index.tsx